import React from "react";
import { OptimizedGantt } from "@planzone/dto";
import { Views, DetailsViews } from "./api/views";

const Context = React.createContext<{
  cell: { height: number; width: number };
  currentView: Views;
  detailsView: DetailsViews;
  areDetailsOpen: boolean;
  selectDetailsView(detailsView: DetailsViews): void;
  selectView(currentView: Views): void;

  hoveredElement: OptimizedGantt[number] | null;
  hoverElement(element: OptimizedGantt[number]): void;
  leaveElement(element: OptimizedGantt[number]): void;

  areWorkloadsToggled: boolean;
  toggleWorkloads(): void;

  areDelaysToggled: boolean;
  toggleDelays(): void;

  areDerivationsToggled: boolean;
  toggleDerivations(): void;

  elementsNbrMap?: { [key: string]: number };
  setProjectElementsNbr(id: string, nbr: number): void;
}>({
  setProjectElementsNbr() {},
  cell: { height: 25, width: 25 },
  currentView: Views.DAILY,
  detailsView: DetailsViews.DATES,
  areDetailsOpen: false,
  selectDetailsView() {},
  selectView() {},

  hoveredElement: null,
  hoverElement() {},
  leaveElement() {},

  areWorkloadsToggled: false,
  toggleWorkloads() {},

  areDelaysToggled: false,
  toggleDelays() {},

  areDerivationsToggled: false,
  toggleDerivations() {},

  elementsNbrMap: undefined,
});

export { Context };
